import { useCallback, useEffect } from 'react'

type Input = {
  isModified: boolean
  onLeavePage: () => void
}

export const usePreventPageOut = ({ isModified, onLeavePage }: Input) => {
  const confirmLeave = useCallback(() => {
    if (window.confirm('変更した内容が破棄されますがよろしいですか？')) {
      onLeavePage()
    }
  }, [onLeavePage])

  const handleBeforeUnload = useCallback(() => {
    if (!isModified) {
      onLeavePage()
      return
    }
    confirmLeave()
  }, [confirmLeave, onLeavePage, isModified])

  useEffect(() => {
    const handler = (event: BeforeUnloadEvent) => {
      if (!isModified) return
      event.preventDefault()
    }

    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [isModified])

  return { handleBeforeUnload }
}
